import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGOUT,
    LOGOUT_COMPLETE,
    ACCESS_NOT_ALLOWED,
    ACCESS_ALLOWED,
    SESSION_EXPIRED,
    CHANGE_TOKEN,
    CHANGE_TOTEM_TOKEN,
    FETCH_ROUTES_SUCCESS,
  } from 'actionTypes'
  
  // import { translate } from 'react-i18next'
  
  const defaultState = {
    isAuthenticating: false,
    isAuthenticated: false,
    user: null,
    error: null,
    message: null,
    isUserMatriz: null
  }
  
  function authenticate(state = defaultState, action) {
    switch (action.type) {
      case LOGIN_REQUEST:
        return {
          ...state,
          isAuthenticating: true,
          message: 'Autenticando...',
          error: null,
        }
  
      case LOGIN_SUCCESS:
        return {
          ...state,
          isAuthenticated: true,
          isAuthenticating: false,
          user: action.payload,
          isUserMatriz: action.payload.isUserMatriz,
          error: null,
          message: 'Autenticação realizada com sucesso',
        }
  
      case LOGIN_FAILURE:
        return {
          ...state,
          isAuthenticated: false,
          isAuthenticating: false,
          user: null,
          error: action.payload,
          message: 'Falha na autenticação',
          isUserMatriz: null
        }
  
      case LOGOUT:
        return {
          ...state,
          isAuthenticated: false,
          isAuthenticating: false,
          user: null,
          error: null,
          message: 'Logout realizado com sucesso',
          isUserMatriz: null
        }
  
      case ACCESS_NOT_ALLOWED:
        return {
          ...state,
          error: 'Esse usuário não tem acesso a essa funcionalidade',
          isFunctionAllowed: false,
        }
  
      case ACCESS_ALLOWED:
        return {
          ...state,
          isFunctionAllowed: true,
          error: null,
        }
  
      case LOGOUT_COMPLETE:
        return {
          ...state,
          isAuthenticated: false,
        }
  
      case SESSION_EXPIRED:
        return {
          ...state,
          isAuthenticated: false,
          isAuthenticating: false,
          user: null,
          error: { message: { dsMessage: 'Sua sessão expirou!' } },
          message: 'Sua sessão expirou!',
          isUserMatriz: null
        }
  
      case CHANGE_TOKEN:
        return {
          ...state,
          user: {
            ...state.user,
            dsToken: action.payload,
          },
        }

      case CHANGE_TOTEM_TOKEN:
        return {
          ...state,
          user: {
            ...state.user,
            totemToken: action.payload,
          },
        }
  
      case FETCH_ROUTES_SUCCESS:
        return {
          ...state,
          allowedChildRoutes: action.payload,
        }
  
      default:
        return state
    }
  }
  
  export default authenticate